module.exports = __webpack_public_path__ + "img/search-not-found.0dcba044.svg";